import { Spacing } from '@persona-id/design-tokens';
import { ReactElement } from 'react';
import styled from 'styled-components';

import Tooltip from 'design-system/components/Tooltip';

const TooltipContentContainer = styled.div`
  max-width: 300px;
  overflow-wrap: break-word;
  text-align: center;
  padding: 0 ${Spacing[2]};
`;

const EditorNavItemTooltip = ({
  trigger,
  content,
  shouldTriggerTooltip,
}: {
  trigger: ReactElement;
  content: string;
  shouldTriggerTooltip?: boolean;
}) => {
  return shouldTriggerTooltip ? (
    // wrap trigger so tooltip component can correctly calculate bounds
    <Tooltip side='right' trigger={<div>{trigger}</div>} interactive={false}>
      <TooltipContentContainer>{content}</TooltipContentContainer>
    </Tooltip>
  ) : (
    trigger
  );
};

export default EditorNavItemTooltip;
